import { createContext, useContext, useState, useEffect, useCallback } from "react";

const ThemeContext = createContext({ theme: "dark", toggleTheme: () => {} });

export function ThemeProvider({ userId, children }) {
  const storageKey = userId ? `fitsmith_theme_${userId}` : "fitsmith_theme";

  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem(storageKey);
    if (saved === "light" || saved === "dark") return saved;
    // Volg OS voorkeur als standaard
    return window.matchMedia?.("(prefers-color-scheme: light)").matches ? "light" : "dark";
  });

  // Herlaad voorkeur als gebruiker wisselt (login/logout)
  useEffect(() => {
    const saved = localStorage.getItem(storageKey);
    if (saved === "light" || saved === "dark") setTheme(saved);
  }, [storageKey]);

  const toggleTheme = useCallback(() => {
    setTheme(prev => {
      const next = prev === "dark" ? "light" : "dark";
      localStorage.setItem(storageKey, next);
      return next;
    });
  }, [storageKey]);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
